import {
  useCreateFormRequestMutation,
  useCreateReviewFormRequestMutation,
} from "services/api/api";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import MaskedInput from "react-text-mask";
import { useState } from "react";
import { Link } from "react-router-dom";
import ModalPopup from "shared/ModalPopup";
import FormResult from "shared/FormResult";
import { Review } from "services/api/types/DataTypes";

const ReviewsForm = ({ setShow }: { setShow: (boolean) => void }) => {
  const [createFormRequest] = useCreateReviewFormRequestMutation();
  const phoneNumberMask = [
    "+",
    "7",
    "(",
    /\d/,
    /\d/,
    /\d/,
    ")",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
  ];
  const validationsSchema = yup.object().shape({
    name: yup
      .string()
      .min(3, "Слишком короткое имя")
      .matches(/[а-я,А-Я]/, "Имя должно содержать только русские буквы")
      .matches(/^([^0-9]*)$/gm, "'Имя должно содержать только буквы")
      .required("Обязательно к заполнению"),
    phone: yup
      .string()
      .required("Обязательно к заполнению")
      .transform((value) => value.replace(/[^\d]/g, ""))
      .min(11, "Введите корректный номер"),
    comment: yup
      .string()
      .test("nourl", "Текст сообщения введен некорректно", (value) => {
        return !value.match(/(www\.)|(https?:)|(\.ru)|(\.com)|(\.рф)/);
      })
      .required("Обязательно к заполнению"),
    check: yup
      .boolean()
      .oneOf([true], "Необходимо согласие на обработку персональных данных"),
    agree: yup
      .boolean()
      .oneOf([true], "Необходимо согласие с политикой конфиденциальности"),
  });
  const [resultShow, setResultShow] = useState(false);
  const [resultText, setResultText] = useState({
    status: "",
    text: "",
  });
  const closeAllPopup = (state: boolean) => {
    setResultShow(state);
    setShow(state);
  };
  return (
    <>
      <h2>Написать отзыв</h2>
      <Formik
        initialValues={{
          name: "",
          phone: "",
          comment: "",
          check: false,
          agree: false,
        }}
        validateOnBlur
        onSubmit={async ({ name, phone, comment, check, agree }, { resetForm }) => {
          const body: Review = {
            name,
            phone,
            comment,
            check,
            agree,
          };
          let res = await createFormRequest({ body });
          if (res["error"]) {
            setResultShow(true);
            setResultText({
              status: "Ошибка!",
              text: `Попробуйте позже`,
            });
          } else {
            resetForm();
            setResultShow(true);
            setResultText({
              status: "Спасибо!",
              text: `Ваша заявка отправлена`,
            });
          }
        }}
        validationSchema={validationsSchema}
      >
        {({ handleSubmit, isSubmitting, touched, errors }) => (
          <Form className="popup-form review-form" onSubmit={handleSubmit}>
            <div className="form-field">
              <Field
                type="text"
                name="name"
                placeholder="ФИО"
                className="form-entry"
              />
              <ErrorMessage
                name="name"
                component="span"
                className="form-error"
              />
            </div>
            <div className="form-field">
              <Field name="phone">
                {({ field }) => (
                  <MaskedInput
                    {...field}
                    mask={phoneNumberMask}
                    placeholder="+7 (___) __ - __"
                    type="tel"
                    className="form-entry"
                  />
                )}
              </Field>
              <ErrorMessage
                name="phone"
                component="span"
                className="form-error"
              />
            </div>
            <div className="form-field">
              <Field
                as="textarea"
                placeholder="Тест сообщения"
                name="comment"
                className="form-entry"
              />
              <ErrorMessage
                name="comment"
                component="span"
                className="form-error"
              />
            </div>
            <div className="popup_controls">
              <label className="popup_agreement">
                <Field name="check" type="checkbox" />
                <span className="popup_agreement__inner">
                  Я даю согласие на обработку персональных данных, в том числе
                  сервисом "Яндекс.Метрика"
                </span>
              </label>
              <label className="popup_agreement">
                <Field name="agree" type="checkbox" />
                <span className="popup_agreement__inner">
                  Я ознакомлен с
                  <Link to="/politic" target="_blank">
                    политикой в отношении обработки персональных данных
                  </Link>
                </span>
              </label>
              <ErrorMessage
                name="agree"
                component="span"
                className="form-error"
              />
              <ErrorMessage
                name="check"
                component="span"
                className="form-error"
              />
              <button
                className="popup_btn"
                type="submit"
                disabled={!touched.check || errors.check || !touched.agree || errors.agree ? true : false}
              >
                Отправить
              </button>
            </div>
          </Form>
        )}
      </Formik>
      {resultShow && (
        <ModalPopup
          setShow={
            resultText.status === "Ошибка!" ? setResultShow : closeAllPopup
          }
          addedClass="form-result"
        >
          <FormResult status={resultText.status} text={resultText.text} />
        </ModalPopup>
      )}
    </>
  );
};
export default ReviewsForm;
